import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { forEach, find, get } from 'lodash';
import ReactTooltip from 'react-tooltip';

import features from 'lib/common/features';
import { fetchHtml } from 'lib/common/fetcher';

import PromoCode from 'components/PromoCode';

let bestAvailableUrl;
let bestAvailableLabelButton;
let bestAvailableLabelSelect;
let levelSelectorLabelHelp;

class LevelSelectorContainer extends Component {
  constructor(props) {
    bestAvailableUrl = features.getOption('bestAvailableLink', 'url');
    bestAvailableLabelButton = features.getOption('bestAvailableLink', 'labelButton');
    bestAvailableLabelSelect = features.getOption('bestAvailableLink', 'labelSelect');
    levelSelectorLabelHelp = features.getOption('levelSelector', 'labelHelp');

    super(props);

    this.state = {
      imageMask: null,
      isInactive: true,
      activeMask: null
    };

    this.setAsActive = this.setAsActive.bind(this);
    this.setAsInactive = this.setAsInactive.bind(this);
    this.handleLevelSelection = this.handleLevelSelection.bind(this);
    this.handleLevelSelectionFallback = this.handleLevelSelectionFallback.bind(
      this
    );
    this.renderLevelSelectorGraphic = this.renderLevelSelectorGraphic.bind(
      this
    );
    this.renderFallbackForm = this.renderFallbackForm.bind(this);
  }

  componentDidMount() {
    fetchHtml(this.props.levelSelectorConfig.imageMask).then(imageMask => {
      this.setState({
        imageMask: imageMask
      });
    });
  }

  componentDidUpdate() {
    const { screenZoneData } = this.props;

    if (
      screenZoneData &&
      !this.initialisedHotspots &&
      this._hotspotsEls &&
      this._hotspotsEls.length
    ) {
      const { levelSelectorConfig } = this.props;

      /**
       * Associate tool-tip labels with hit-areas
       */
      forEach(this._hotspotsEls, el => {
        let hitAreaLabel = find(
          levelSelectorConfig.hitAreaLabels,
          x => x.id === el.id
        );

        const zoneData = find(screenZoneData, x => x.screen === parseInt(hitAreaLabel.screen));

        if (hitAreaLabel) {
          el.setAttributeNS(null, 'data-html', true);
          el.setAttributeNS(null, 'data-tip', `
            <b>${hitAreaLabel.label}</b>
            <br><br>
            ${zoneData.avail} seats available
          `);
        }
      });

      forEach(this._hotspotsEls, el => {
        el.addEventListener('mouseenter', () => {
          ReactTooltip.show(el);

          /**
           * Force rendering, trigger mouse-move behaviour
           */
          setTimeout(function() {
            ReactTooltip.rebuild();
          }, 0);

          this.setState({
            activeMask: el
          });
        });

        el.addEventListener('mouseleave', () => {
          ReactTooltip.hide();

          this.setState({
            activeMask: null
          });
        });

        el.addEventListener('click', () => {
          this.handleLevelSelection(el.id);
        });
      });

      this.initialisedHotspots = true;
    }
  }

  setAsActive() {
    this.setState({
      isInactive: false
    });
  }

  setAsInactive() {
    this.setState({
      isInactive: true
    });
  }

  handleLevelSelection(id) {
    let selector = id.replace('hit-area-', '');
    let newZoom = get(this.props.levelSelectorConfig, 'zoomLevel', 5);

    const hitAreaLabels = this.props.levelSelectorConfig.hitAreaLabels;
    const hitArea = hitAreaLabels.find(area => area.id === id);
    const isGa = get(hitArea, 'isGa', false);
    const isEmbed = get(hitArea, 'isEmbed', false);
    const extraParams = get(hitArea, 'params');
    this.props.onLevelSelected(selector, isGa, newZoom, extraParams, isEmbed);
  }

  handleLevelSelectionFallback(e) {
    e.preventDefault();
    let val = this._fallbackSelect.value;
    if (val) {
      this.handleLevelSelection(val);
    }
  }

  renderLevelSelectorGraphic() {
    /* eslint-disable react/no-danger */
    return (
      <div className="syos-level-selector">
        <div
          className={classnames({
            'syos-level-selector__header': true,
            'syos-level-selector__header--has-extra': features.isEnabled(
              'promoCode'
            )
          })}
        >
          {features.isEnabled('promoCode') && (
            <div className="syos-level-selector__header__extra">
              <PromoCode onPromoCodeReady={this.props.onPromoCodeReady} />
            </div>
          )}
        </div>
        <div className="syos-level-selector__topbar">
          <div className="syos-level-selector__topbar__label">
            {levelSelectorLabelHelp}
          </div>
          {bestAvailableUrl && (
            <div className="syos-level-selector__topbar__action">
              <a
                className="syos-button"
                href={`${bestAvailableUrl}${this.props.performanceId}`}
              >
                {bestAvailableLabelButton}
              </a>
            </div>
          )}
        </div>
        <div
          className="syos-level-selector__graphic"
          onMouseEnter={this.setAsActive}
          onMouseLeave={this.setAsInactive}
        >
          <div
            className="syos-level-selector__hotspots"
            ref={el => {
              if (el) {
                let svg = el.firstChild;
                this._hotspotsEls = svg.querySelectorAll("[id^='hit-area-']");
                this._hotspotsViewBox = svg.getAttribute('viewBox');
              }
            }}
            dangerouslySetInnerHTML={{
              __html: this.state.imageMask
            }}
          />

          {this.state.activeMask && (
            <svg
              className="syos-level-selector__mask"
              viewBox={this._hotspotsViewBox}
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <clipPath
                  id="mask"
                  dangerouslySetInnerHTML={{
                    __html: new XMLSerializer().serializeToString(
                      this.state.activeMask
                    )
                  }}
                />
              </defs>
              <image
                xlinkHref={this.props.levelSelectorConfig.imageHighlighted}
                x="0"
                y="0"
                height="100%"
                width="100%"
                clipPath="url(#mask)"
              />
            </svg>
          )}

          <svg
            className="syos-level-selector__mask-image"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <image
              xlinkHref={
                this.state.isInactive
                  ? this.props.levelSelectorConfig.imageHighlighted
                  : this.props.levelSelectorConfig.imageDefault
              }
              x="0"
              y="0"
              height="100%"
              width="100%"
            />
          </svg>
        </div>
      </div>
    );
  }

  renderFallbackForm() {
    return (
      <form
        className="syos-level-selector-form"
        onSubmit={this.handleLevelSelectionFallback}
      >
        <label
          className="syos-level-selector-form__label"
          htmlFor="select-level-fallback"
        >
          {levelSelectorLabelHelp}
        </label>
        <select
          className="syos-level-selector-form__select"
          id="select-level-fallback"
          ref={el => (this._fallbackSelect = el)}
        >
          <optgroup label="Select a level">
            {this.props.levelSelectorConfig.hitAreaLabels.map(item => {
              return (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              );
            })}
          </optgroup>
        </select>
        <input
          className="syos-level-selector-form__action syos-button"
          type="submit"
          value="Select"
        />

        {bestAvailableUrl && (
          <a
            className="syos-level-selector-form__best-available"
            href={`${bestAvailableUrl}${this.props.performanceId}`}
          >
            {bestAvailableLabelSelect}
          </a>
        )}
      </form>
    );
  }

  render() {
    return this.state.imageMask ? (
      <div className="syos-level-selector-container">
        {this.renderLevelSelectorGraphic()}
        {this.renderFallbackForm()}
        <ReactTooltip />
      </div>
    ) : null;
  }
}

LevelSelectorContainer.propTypes = {
  performanceId: PropTypes.number,
  levelSelectorConfig: PropTypes.object.isRequired,
  screenZoneData: PropTypes.array.isRequired,
  onLevelSelected: PropTypes.func.isRequired,
  onPromoCodeReady: PropTypes.func.isRequired
};

export default LevelSelectorContainer;



// WEBPACK FOOTER //
// ./src/javascripts/containers/LevelSelectorContainer.js